import React, { useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Mail, Send } from 'lucide-react';
import { showSuccess, showError } from "@/utils/toast";

interface ContactFormModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

const ContactFormModal: React.FC<ContactFormModalProps> = ({ isOpen, onOpenChange }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!name.trim() || !email.trim() || !subject.trim() || !message.trim()) {
      showError('Kérjük, töltse ki az összes mezőt!');
      return;
    }

    if (!/\S+@\S+\.\S+/.test(email)) {
      showError('Kérjük, érvényes email címet adjon meg!');
      return;
    }

    // Itt történne a tényleges üzenetküldés (pl. API hívás)
    console.log({ name, email, subject, message });
    showSuccess('Üzenetét sikeresen elküldtük! Hamarosan válaszolunk.');

    // Űrlap alaphelyzetbe állítása és bezárása
    setName('');
    setEmail('');
    setSubject('');
    setMessage('');
    onOpenChange(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px] bg-card text-card-foreground border-border shadow-lg">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-primary flex items-center gap-2">
            <Mail size={24} /> Kapcsolatfelvétel
          </DialogTitle>
          <DialogDescription className="text-muted-foreground mt-2">
            Kérdése van, javaslata, vagy hibát szeretne jelenteni? Írjon nekünk!
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="grid gap-4 py-4">
          <div>
            <Label htmlFor="contact-name" className="text-muted-foreground">Neve</Label>
            <Input
              id="contact-name"
              type="text"
              placeholder="Az Ön neve"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="mt-1 bg-secondary text-secondary-foreground border-border focus:border-primary focus:ring-primary"
              required
            />
          </div>
          <div>
            <Label htmlFor="contact-email" className="text-muted-foreground">Email címe</Label>
            <Input
              id="contact-email"
              type="email"
              placeholder="email@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 bg-secondary text-secondary-foreground border-border focus:border-primary focus:ring-primary"
              required
            />
          </div>
          <div>
            <Label htmlFor="contact-subject" className="text-muted-foreground">Tárgy</Label>
            <Input
              id="contact-subject"
              type="text"
              placeholder="Üzenet tárgya"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              className="mt-1 bg-secondary text-secondary-foreground border-border focus:border-primary focus:ring-primary"
              required
            />
          </div>
          <div>
            <Label htmlFor="contact-message" className="text-muted-foreground">Üzenet</Label>
            <Textarea
              id="contact-message"
              placeholder="Írja ide üzenetét..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="mt-1 bg-secondary text-secondary-foreground border-border focus:border-primary focus:ring-primary min-h-[100px]"
              required
            />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} className="bg-muted text-muted-foreground border-border hover:bg-secondary hover:text-secondary-foreground">
              Mégsem
            </Button>
            <Button type="submit" className="bg-primary text-primary-foreground hover:bg-accent hover:text-accent-foreground">
              <Send size={16} className="mr-2" /> Üzenet küldése
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ContactFormModal;